const dispatch = require("../../store.js").dispatch;
const Server = require("../../Server.js");

const NexusDataActions = require("../../actions/metadata/NexusDataActions.js");

const NexusDataActionCreators = {
    LoadTargets() {
        dispatch({
            type: NexusDataActions.LoadTargets
        });

        dispatch((thunkDispatch) => {
            thunkDispatch({
                type: NexusDataActions.LoadTargets
            });

            Server.Get("nexus-target/current-user")
                .then((response) => {
                    return response.json();
                })
                .then((json) => {
                    thunkDispatch({
                        type: NexusDataActions.LoadedTargets,
                        Data: json
                    });
                })
                .catch((ex) => {
                    thunkDispatch({
                        type: NexusDataActions.LoadTargetsErrored,
                        Error: ex
                    });
                });
        });
    },
    SelectTarget(target) {
        dispatch({
            type: NexusDataActions.TargetSelected,
            Target: target
        });
    }
};

module.exports = NexusDataActionCreators;


// WEBPACK FOOTER //
// ./src/actionCreators/metadata/NexusDataActionCreators.js